import cn from 'classnames'

import SelectDropdown from 'components/SelectDropdown'

import { TOptionSelectDropdown } from 'types/components'

type TProps = {
  label: string
  selectOptions: TOptionSelectDropdown[]
  onChangeSelectOption: (value: TOptionSelectDropdown) => void
  defaultSelectOption?: TOptionSelectDropdown
  isActive?: boolean
  disabledDropdown?: boolean
  disabledLabel?: boolean
  isHighlited?: boolean
  isDropdown?: boolean
}

const CheckAccordionItem = ({
  label,
  selectOptions,
  defaultSelectOption,
  onChangeSelectOption,
  isActive = true,
  isHighlited = false,
  disabledDropdown,
  disabledLabel,
  isDropdown = true,
}: TProps) => {
  return (
    <div className="check-accordion-option">
      <p
        className={cn(
          'check-accordion-option__label',
          { '-active': isHighlited },
          { '-disabled': disabledLabel }
        )}
      >
        {label}
      </p>
      {isActive && isDropdown && (
        <SelectDropdown
          options={selectOptions}
          onChange={onChangeSelectOption}
          defaultOption={defaultSelectOption}
          disabled={disabledDropdown}
        />
      )}
    </div>
  )
}

export default CheckAccordionItem
